import { render, staticRenderFns } from "./SimpleTable.vue?vue&type=template&id=161df7cc&scoped=true"
import script from "./SimpleTable.vue?vue&type=script&setup=true&lang=js"
export * from "./SimpleTable.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SimpleTable.vue?vue&type=style&index=0&id=161df7cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161df7cc",
  null
  
)

export default component.exports